import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TimelineResponse } from '../../models/timeline';
import { TimelineService } from '../../services/timeline.service';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { AppEventListenerService } from 'src/app/core/services/app-event-listener.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'timeline-preview',
  templateUrl: './timeline-preview.component.html',
  styleUrls: ['./timeline-preview.component.scss'],
})
export class TimelinePreviewComponent implements OnInit, OnChanges, OnDestroy {
  baseImageUrl = environment.baseImageUrl;
  @Input() farmId: number;
  @Input() cropId: number;
  @Input() showHeader: boolean = true;
  @Input() isUpdate: boolean = false;
  timelineData: TimelineResponse[];
  sowingDate: string;
  harvestDate: string;
  timelineShow: boolean = true;
  farmListener: Subscription;
  constructor(private timelineService: TimelineService, private router: Router, private dateTimeService: DateTimeService) { }

  ngOnDestroy(): void {
    if (this.farmListener) {
      this.farmListener.unsubscribe();
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (this.isUpdate) {
      this.getList();
    }

  }

  ngOnInit() {
    this.getList();
    if (!this.farmListener) {
      this.farmListener = AppEventListenerService.GetListener.subscribe(res => {
        console.log("timeline-preview-oninit",res)
        this.getList();
      });
    }

  }

  getList() {
    this.timelineService.getTimelineList(this.farmId, this.cropId).subscribe(res => {
      if (res.IsSuccess) {
        if (res.Data && res.Data.length > 0) {
          let timelineList: Array<any> = [];
          res.Data.forEach(e => {
            if (e.Id != -1) {
              timelineList.push(e);
            }
          });
          if (timelineList.length == 0) {
            this.timelineShow = false;
          } else {
            this.timelineShow = true;
            this.timelineData = timelineList
          }
        }
      }
    });
  }

  timelinePage() {
    let url = this.router.url.split("?")[0] + "/timeline";
    this.router.navigate([url], {
      queryParams: {
        farmId: this.farmId,
        cropId: this.cropId
      }
    });
  }
}
